import axios, { AxiosError } from 'axios';

export interface ICep {
  cep: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  service: string;
}

export async function getCep(cep: string): Promise<ICep> {
  try {
    const response = await axios.get(`https://brasilapi.com.br/api/cep/v1/${cep}`, {
      timeout: 10000,
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.code === 'ECONNABORTED') {
        throw new Error('Tempo limite excedido ao buscar CEP');
      }
      if (error.response?.status === 404) {
        throw new Error('CEP não encontrado');
      }
      throw new Error('Erro ao buscar CEP. Tente novamente mais tarde.');
    }
    throw error;
  }
}
